import { render, staticRenderFns } from "./OrderStartModal.vue?vue&type=template&id=424232f1&"
import script from "./OrderStartModal.vue?vue&type=script&lang=js&"
export * from "./OrderStartModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderStartModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports